<template>
  <div class="flex flex-column items-end">
    <a @click="showOptionsTrigger" class="pa2 h-100 pointer">
      <font-awesome-icon :class="{'textColor': inHome, 'textColor': !inHome}" icon="ellipsis-v"/>
    </a>
    <track-options :track="track" :showOptions="showOptions" :inPlayer="inPlayer" :inMyLikes="inMyLikes" :playlist="playlist "
                   @close-dropdown="closeDropdown"/>
  </div>
</template>


<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import TrackOptions from './TrackOptions.vue'

  export default {
    name: 'track-options-button',
    props: {
      track: {
        require: true
      },
      inPlayer: {
        default: false
      },
      playlist: {
        default: null
      },
      inHome: {
        default: false
      },
      inMyLikes: {
        default: false
      }
    },
    data () {
      return {
        showOptions: false
      }
    },
    components: {
      FontAwesomeIcon,
      TrackOptions
    },
    methods: {
      showOptionsTrigger () {
        this.showOptions = !this.showOptions
      },
      closeDropdown () {
        this.showOptions = false
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackOptionsButton.vue